'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$25() {
  this.b6M = null;
  this.b6N = false;
}
export { $c_Lpresto_LoginPageView$$anon$25 as $c_Lpresto_LoginPageView$$anon$25 };
$p = $c_Lpresto_LoginPageView$$anon$25.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$25;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$25() {
}
export { $h_Lpresto_LoginPageView$$anon$25 as $h_Lpresto_LoginPageView$$anon$25 };
$h_Lpresto_LoginPageView$$anon$25.prototype = $p;
$p.P = (function() {
  if ((!this.b6N)) {
    this.b6M = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.b6N = true;
  }
  return this.b6M;
});
var $d_Lpresto_LoginPageView$$anon$25 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$25, "presto.LoginPageView$$anon$25", ({
  Mg: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_LoginPageView$$anon$25 as $d_Lpresto_LoginPageView$$anon$25 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$25.js.map
